import { useContext } from 'react';
import { PageContext, EMPTY_PAGE_CONTEXT } from '../components/context/page-context';
export var usePage = function usePage() {
  return useContext(PageContext) || EMPTY_PAGE_CONTEXT;
};